import styled from "styled-components";

export const Container = styled.div`
    cursor: pointer;
    display: inline-flex;
    vertical-align: top;
    margin-right: 0.5rem;
    * > svg {
        margin: 0 0 0 0.2rem;
        width: 0.7rem;
    }
`;

export const StyledLink = styled.a`
    background-color: ${globalThis.config.colors.gray7};
    padding: 0.1rem 0.5rem;
`;
